import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import apiService from "../backend/api";

const useProjects = (page, username, limit = 10) => {
  const queryClient = useQueryClient();

  // Sync in-progress project statuses when component mounts
  useEffect(() => {
    if (!username) return;

    const syncStatuses = async () => {
      try {
        const result = await apiService.syncProjectStatuses();
        // If any projects were synced, invalidate the query to refresh data
        if (result.projectsSynced > 0) {
          queryClient.invalidateQueries(["projects", username]);
        }
      } catch (err) {
        // Silent fail - sync is best-effort
        console.warn("Status sync failed:", err.message);
      }
    };

    syncStatuses();
  }, [username, queryClient]);

  return useQuery({
    queryKey: ["projects", username, page, limit],
    queryFn: async () => {
      const data = await apiService.getUserProjects(page, username, limit);
      return data;
    },
    enabled: !!username,
    keepPreviousData: true,
  });
};

export default useProjects;
